import WebRedeem from "@/Core/Redeem/WebRedeem";
import {RedeemConfigEntity, RedeemRecordInfo, RedeemResult} from "@/Core/Redeem/redeemEntity";
import {redeemConst} from "@/Core/Redeem/RedeemConst";
import {HttpResponse} from "@/Fwk/Http/HttpConfig";
import Util from "@/Master/Util";
import {RecordFailState, RedeemKycState, RedeemRecordState, RedeemResultCode} from "@/Core/Redeem/redeemEnum";
import LoginNetManager from "@/Core/Login/LoginNetManager";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {RedeemDialogFC} from "@/app/(redeem)/UI/RedeemDialogFC";
import GameMsgUtil from "@/app/(game)/GameMsgUtil";

export class RedeemManager {


    public static tag = '[Redeem]'
    public static _instance:RedeemManager| null = null;
    public static get Instance(){
        if (this._instance == null) {
            this._instance = new RedeemManager();
            this._instance.InitData();
        }
        return this._instance;
    };

    public InitData() {

    }

    //获取兑换记录
    static GetRedeemRecord(page: number, pageSize: number, onComplete: (totalPage: number, result: RedeemRecordInfo[]) => void) {
        //再去拉取历史接口，才能匹配正在提现中的订单可取消
        WebRedeem.Instance.RequestRedeemOrderList(page, pageSize, (records) => {
            let recordInfos: RedeemRecordInfo[] = [];
            //如果有新的兑换记录，说明兑换成功，否则说明玩家发起了兑换，但服务器并未收到。
            if (records && records.list && records.list.length > 0) {
                for (let i = 0; i < records.list.length; i++) {
                    const orderData = records.list[i];
                    const info = this.CreateRecordInfo(orderData);
                    recordInfos.push(info)
                }
            }
            onComplete(records.totalPage, recordInfos);
        });
    }

    static CreateRecordInfo(orderData: RedeemOrderData): RedeemRecordInfo {
        // const dollar = DriveUtil.ToNormalUnit(orderData.money);
        const dollar = orderData.money;
        return {
            account: orderData.showAccount,
            dateTime: new Date(orderData.createTime).toLocaleString(),
            dollar: dollar,
            fee: orderData.poundage,
            state: this.GetRecordState(orderData),
            failState: this.GetFailState(orderData.orderStatus),
            orderStatus: orderData.orderStatus,
            id: orderData.orderId,
            channelType: orderData.channelType,
            kycState: orderData.kycStatus as RedeemKycState,
            kycUrl: orderData.kycUrl,
            comment: orderData.comment,//订单错误备注信息
        };
    }

    //获取订单状态
    static GetRecordState(orderData: RedeemOrderData): RedeemRecordState {
        //打款订单状态(HS_WITHDRAW_ORDER_STATUS:
        // 100-已创建
        // 101-待人工审核(自动审核失败)
        // 102-待完善信息(审核通过)
        // 103-待完善信息(审核通过)
        // 200-打款成功
        // 300-拦截打款(金币不退)
        // 400-取消打款(审核拒绝)
        // 401-用户取消
        // 500-打款中
        // 600-打款失败)

        // orderStatus-500/600/200/300/400时，kycStatus是3
        switch (orderData.orderStatus) {
            case 200:// 200-打款成功
                return RedeemRecordState.Successful;
            case 100://100-已创建
            case 101://101-待人工审核(自动审核失败)
                if (orderData.isCancel){
                    return RedeemRecordState.ReviewCanCancel;
                }else{
                    return RedeemRecordState.ReviewNoCancel;
                }
            case 102: //kycStatus可能是1/2
                if (orderData.kycStatus == RedeemKycState.PendingCheck){
                    return RedeemRecordState.KycOpen;
                }else{
                    return RedeemRecordState.KycProcess;
                }
            case 103://kycStatus是5
                return RedeemRecordState.KycOpenRetry;
            case 500:
                // return RedeemRecordState.KycOpen;
                return RedeemRecordState.Process;
            default:
                return RedeemRecordState.Fail;
        }
    }

    static GetFailState(status:number) {
        // ORDER_STATUS_CREATE("100", "创建兑换单（待审核）"),
        // AUTO_AUDIT_FAIL("101", "自动审核不通过"),
        // ORDER_STATUS_PAID("200", "兑换成功"),
        // ORDER_STATUS_REFUSED("300", "拒绝兑换（不退游戏内金额"),
        // ORDER_STATUS_CANCEL("400", "取消兑换（退游戏内金额"),
        // ORDER_STATUS_USER_CANCEL("401", "用户主动取消兑换"),
        // ORDER_STATUS_PAYING("500", "打款中"),
        // ORDER_STATUS_PAID_FAIL("600", "兑换失败"),
        //
        // 100、101、500: 兑换订单创建完成，兑换进行中
        // 200、300：兑换完结状态，用户sc币确认扣除
        // 400、401、600：兑换完结状态，用户sc币退还
        switch (status) {
            case 100:
            case 200:
            case 500:
                return RecordFailState.None;
            case 101:
                return RecordFailState.AutoReject;
            case 300:
                return RecordFailState.PeopleReject;
            case 400:
                return RecordFailState.ThirdPartyReject;
            case 401:
                return RecordFailState.Cancel;
            case 600:
                return RecordFailState.PayFail;
            case 700:
                return RecordFailState.LongLongAgo;
            case 701:
                return RecordFailState.OrderFallback;
        }

        if (Util.isLog) {
            console.log(`未知的兑换订单状态:${status}`)
        }

        return RecordFailState.None;
    }

    static GetRedeemConfig(onComplete: (res: RedeemConfigEntity) => void) {
        let  entity = new RedeemConfigEntity();
        WebRedeem.Instance.RequestRedeemConfig( (data:ResponseRedeemConfigData[]) => {
            entity.isOk = true;
            entity.channelList = data;
            onComplete(entity);
            //如果有新的兑换记录，说明兑换成功，否则说明玩家发起了兑换，但服务器并未收到。
        });
    }

    static CheckRedeemConfig(onComplete: (res: any) => void){
        WebRedeem.Instance.RequestRedeemChannelCheck(redeemConst.peyType, (data:HttpResponse<ResponseRedeemChannelCheckData>) => {
            if (Util.isLog){
                console.log('CheckRedeemConfig',data);
            }
            if (data.code == 200) {
                onComplete(data);
            }else{
                // onComplete('');
            }
        });
    }

    static async GetRedeemCheckAsync(outType: number) {
        const response = await WebRedeem.Instance.RequestRedeemChannelCheck(outType, (data: HttpResponse<ResponseRedeemChannelCheckData>) => {
            if (Util.isLog) {
                console.log('CheckRedeemConfig', data);
            }
        });
        if (response?.code == 200) {
            return response.data;
        }
        return null;
    }

    public CancelRedeem(orderId: string, onFinish: (cancel: boolean) => void) {
        WebRedeem.Instance.RequestRedeemCancel(orderId, data => {
            if (data.code == 200 && null != data.data) {
                let orderStatus = data.data.orderData.orderStatus;
                let cancelResult = data.data.cancelResult;
                if (cancelResult) {
                    onFinish(true);
                    LoginNetManager.Instance.UpdateUserBaseInfo(t => {
                        onFinish(true);
                        RedeemManager.CheckRedeemConfig(a => {
                        });
                    })
                    return;
                }
            }
            onFinish(false);
        })
    }

    static showRedeemDialog(){
        SDialogManagerFC.openDialog(RedeemDialogFC,{
            fcKey:SDialogManagerFC.getFCKey(RedeemDialogFC),
            onClose:(isOk:boolean)=>{
                GameMsgUtil.sendMsgLowerBackToGame();
            }
        })
    }

}